import { render, staticRenderFns } from "./Rococo.vue?vue&type=template&id=628a653b&scoped=true&"
import script from "./Rococo.vue?vue&type=script&lang=js&"
export * from "./Rococo.vue?vue&type=script&lang=js&"
import style0 from "./Rococo.vue?vue&type=style&index=0&id=628a653b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "628a653b",
  null
  
)

export default component.exports